<script>
import PrintPosDteLetter from "./DteLetter/PrintPosDteLetter.vue";

export default PrintPosDteLetter;
</script>
